import request from '@/utils/request'

// 分页查询门店院校
export function pageEduSchool(data) {
  return request({
    url: '/biz/admin/edu/school/page',
    method: 'post',
    data: data
  })
}

// 门店院校详情
export function getEduSchool(data) {
  return request({
    url: '/biz/admin/edu/school/detail',
    method: 'post',
    data: data
  })
}

// 新增门店院校
export function addEduSchool(data) {
  return request({
    url: '/biz/admin/edu/school/add',
    method: 'post',
    data: data
  })
}

// 修改门店院校
export function updateEduSchool(data) {
  return request({
    url: '/biz/admin/edu/school/edit',
    method: 'post',
    data: data
  })
}

// 删除门店院校
export function delEduSchool(data) {
  return request({
    url: '/biz/admin/edu/school/delete',
    method: 'post',
    data: data
  })
}
